import React, { useRef } from 'react';
import { Formik, Field } from 'formik';
import useFormRutine from '../../../../hooks/useForm';
import { InputField } from '../../../../components/formFields/InputField';
import * as Yup from 'yup';
import { SelectFormField } from '../../../../components/formFields/SelectFormField';

const dropdownFeed = [
  { title: 'Ano', id: true as any },
  { title: 'Ne', id: false as any },
];

interface PhaseFormProps {
  formProps?: any;
  submitOutside: any;
  submit: (id: any, values: any) => void;
  error?: any;
  types: any[];
  models: any[];
  reset?: boolean;
  resetConfirm?: any;
}

const PhaseForm = ({
  formProps,
  submitOutside,
  submit,
  error,
  types,
  models,
  reset = false,
  resetConfirm,
}: PhaseFormProps) => {
  const formRef = useRef();

  useFormRutine(formRef, submitOutside, reset, formProps, resetConfirm, error);

  const init = () => ({
    is_active: formProps?.is_active || null,
    name_official: formProps?.name_official || null,
    phase_type: formProps?.phase_type?.id || null,
    model: formProps?.model?.id,
  });

  const validationSchema = Yup.object().shape({
    name_official: Yup.string().nullable().required('Povinné pole'),
    phase_type: Yup.string().nullable().required('Povinné pole'),
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={init()}
        validateOnBlur={false}
        onSubmit={(values) => {
          submit(
            formProps?.id,
            values.is_active !== null ? values : { ...values, is_active: true }
          );
        }}
      >
        {(props) => {
          const { values } = props;

          return (
            <div className="space-y-1">
              <Field
                name="name_official"
                value={values.name_official}
                placeholder="Oficiální název"
                component={InputField}
                label="Oficialni nazev"
                data-testid="phase-form-name-input"
              />
              {formProps && (
                <SelectFormField
                  name="is_active"
                  placeholder=""
                  data={dropdownFeed}
                  label="Aktivní"
                  data-testid="phase-form-active-select"
                />
              )}
              <SelectFormField
                name="phase_type"
                placeholder=""
                data={types || []}
                label="Typ fáze"
                data-testid="phase-form-type-select"
              />
              <SelectFormField
                name="model"
                placeholder=""
                data={models || []}
                label="Model"
                data-testid="phase-form-model-select"
              />
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default PhaseForm;
